import { BugReportPriority, BugReportStatus, BugReportType } from '@/enum/global.enum'
import { nameField } from '@/schema/common/name-field.schema'
import { z } from 'zod'

export const createBugReportSchema = z.object({
  title: nameField('Title', 1, 200),
  description: z
    .string()
    .trim()
    .min(1, 'Description is required')
    .max(5000, 'Description must be less than 5000 characters'),
  type: z.nativeEnum(BugReportType, { message: 'Please select a type' }),
  priority: z.nativeEnum(BugReportPriority, { message: 'Please select a priority' }),
  pageUrl: z.string().trim().max(2000, 'Page URL must be less than 2000 characters').optional().or(z.literal('')),
  attachmentUrl: z
    .any()
    .optional()
    .refine(
      (val) => {
        if (val === undefined || val === null || val === '') return true // allow optional
        let files: File[] = []
        if (typeof FileList !== 'undefined' && val instanceof FileList) files = Array.from(val)
        else if (Array.isArray(val)) files = val
        else if (typeof File !== 'undefined' && val instanceof File) files = [val]
        else return false

        return files.every(
          (file) =>
            file instanceof File &&
            file.size <= 5 * 1024 * 1024 && // 5MB
            ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type)
        )
      },
      {
        message: 'Each file must be a supported format (JPEG, JPG, PNG) and less than 5MB.',
      }
    ),
})

export const updateBugReportSchema = createBugReportSchema.extend({
  id: z.string().min(1, 'Bug Report ID is required'),
})

export type CreateBugReportSchemaType = z.infer<typeof createBugReportSchema>
export type UpdateBugReportSchemaType = z.infer<typeof updateBugReportSchema>

// ONLY FOR SUPER ADMIN USE
export const createBugReportActivitySchema = z.object({
  status: z.nativeEnum(BugReportStatus, { message: 'Please select a status' }),
  description: z
    .string()
    .trim()
    .min(1, 'Your comment is required  ')
    .max(500, 'Your comment must be less than 500 characters'),
})

export const updateBugReportActivitySchema = createBugReportActivitySchema.extend({
  id: z.string().min(1, 'Bug Report Activity ID is required'),
})

export type CreateBugReportActivitySchemaType = z.infer<typeof createBugReportActivitySchema>
export type UpdateBugReportActivitySchemaType = z.infer<typeof updateBugReportActivitySchema>
